export default __webpack_public_path__ + "static/media/personalization.86ad239b.svg";